module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingCreatepointofsale.7ff5b423.png";